<template>
  <!-- 未登录状态时的简易header -->
  <div class="container-simple-layout">
    <header v-if="!ua.wap" class="flex align-center justify-between">
      <Logo />
      <div class="account-nav">
        <div @click="goTo('/payment/price')" class="top-links">{{ $t('price') }}</div>
        <div @click="goTo('/user/login')" class="top-links">{{ $t('login') }}</div>
      </div>
    </header>
    <router-view class="bg" />
    <footer v-if="$route.meta?.showFooter ?? true">
      <div class="links">
        <div v-if="isLocal_JP">
          <a :href="CONFIG.JP_CCB_MAIN_URL" target="_blank">{{ $t('intsig_site') }}</a>
          <a :href="CONFIG.JP_CCB_TERM_URL" target="_blank">{{ $t('terms') }}</a>
          <a :href="CONFIG.JP_CCB_TERM2_URL" target="_blank">{{ $t('privacy') }}</a>
          <a :href="CONFIG.JP_CCB_CONTACT_URL" target="_blank">{{ $t('cc_foot_contact_us') }}</a>
          <a :href="CONFIG.JP_CCB_DOWNLOAD_URL" target="_blank">{{ $t('cc_foot_download') }}</a>
        </div>
        <div v-else>
          <a href="http://www.intsig.com/" target="_blank">{{ $t('intsig_site') }}</a>
          <router-link target="_blank" :to="{ path: '/site/terms' }">{{ $t('terms') }}</router-link>
          <router-link target="_blank" :to="{ path: '/site/privacy' }">{{
            $t('privacy')
          }}</router-link>
          <router-link
            target="_blank"
            v-if="$i18n.locale !== 'zh-cn'"
            :to="{ path: '/site/download' }"
            >{{ $t('download') }}</router-link
          >
        </div>
        <ChangeLang class="change-lang-box"></ChangeLang>
      </div>
      <div class="info">
        <span>{{ $t('copyright', [new Date().getFullYear()]) }}</span>
        <span>web@{{ CONFIG.appVersion }}</span>
      </div>
    </footer>
  </div>
</template>
<script>
  import CONFIG from '@/config'
  import ChangeLang from '@/components/changeLang'
  import Logo from '@/components/Logo'
  import ua from '@/utils/ua'

  export default {
    components: {
      ChangeLang,
      Logo
    },
    data() {
      return {
        ua,
        CONFIG
      }
    },
    computed: {
      isLocal_JP() {
        return this.$store.state.user.language == 'ja-jp'
      }
    },
    methods: {
      goTo(path) {
        if (this.$route.path !== path) {
          let query = {}

          this.$route.query.source && (query.source = this.$route.query.source)
          this.$route.query.campaign && (query.campaign = this.$route.query.campaign)
          this.$route.query.group && (query.group = this.$route.query.group)

          this.$router
            .push({
              path,
              query
            })
            .catch(() => {})
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
  .bg {
    background-color: #f4f5f9;
  }
  .container-simple-layout {
    @extend .bg;
    height: 100vh;
    box-sizing: border-box;
    header {
      position: relative;
      height: 56px;
      background-color: var(--white);
      padding-left: 24px;
      padding-right: 12px;
      box-shadow: 0px -1px 0px 0px var(--gray-e7) inset;
      .account-nav {
        height: 56px;
        display: inline-flex;
        .top-links {
          line-height: 56px;
          padding: 0 12px;
          color: var(--gray-21);
          cursor: pointer;
          &:hover {
            color: var(--blue);
          }
        }
      }
    }
    footer {
      @extend .bg;
      font-size: 14px;
      color: var(--gray-70);
      padding-bottom: 24px;
      .links {
        text-align: center;
        margin-bottom: 12px;
        & > div {
          display: inline-block;
        }
        a {
          cursor: pointer;
          color: var(--gray-5f);
        }
        &:hover {
          text-decoration: underline;
        }
        // & a:not(:last-of-type)::after {
        & a::after {
          content: '';
          display: inline-block;
          position: relative;
          top: 2px;
          width: 1px;
          height: 14px;
          margin: 0 8px;
          background: var(--gray-e7);
        }
      }
      .info {
        text-align: center;
        color: var(--gray-99);
        span:last-child {
          margin-left: 2px;
        }
      }
      .change-lang-box {
        display: inline-block;
        cursor: pointer;
        color: var(--gray-70);
        font-size: 14px;
        .el-dropdown {
          font-size: 14px;
        }
      }
    }

    @media (max-width: 800px) {
      header,
      footer {
        display: none;
      }
    }
  }
</style>
